import _ from 'lodash'

export default {
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      total:0,
      options:{}
    }
  },
  methods: {
    onChangePage(page) {
      this.currentPage = page
      this.fetch()
    }
  }
}
